import { styled, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';

export const sxStyles = {
  container: {
    marginTop: '4rem',
  },
  sectionTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  degreesAwardedWrap: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
    borderRadius: '0.5rem',
    marginTop: '2.25rem',
  }),
  sectionSubtitle: (theme: Theme) => ({
    padding: '1.25rem 2rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  pieChart: {
    marginRight: '2rem',
    width: '200px',
  },
  pieChartLegend: {
    maxWidth: '536px',
    width: '100%',

    '& > h5:first-of-type': {
      marginBottom: '1rem',
    },
  },
};

export const StyledStatisticsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '2rem 2.5rem',

  '& > div:first-of-type': {
    marginBottom: '2rem',
  },

  [theme.breakpoints.up('sm')]: {
    padding: '2.5rem 3rem 4rem 3rem',
  },

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const StyledChartLegendWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  columnGap: '2rem',

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));

export const StyledChartLegendGroup = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isOneColumn',
})<{ isOneColumn: boolean }>(({ isOneColumn, theme }) => ({
  width: 'auto',

  [theme.breakpoints.up('sm')]: {
    width: isOneColumn ? 'auto' : 'calc(50% - 1rem)',
  },
}));

export const StyledChartLegendItem = styled(CoreTypography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  position: 'relative',
  marginBottom: '1rem',
  paddingLeft: '1rem',
  wordBreak: 'break-word',

  ':before': {
    content: "''",
    position: 'absolute',
    backgroundColor: color,
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '50%',
    top: '0.35rem',
    left: 0,
  },
}));
